/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrerrorcorrectionl3Inputs */

const en_qrerrorcorrectionl3 = /** @type {(inputs: Qrerrorcorrectionl3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low`)
};

const de_qrerrorcorrectionl3 = /** @type {(inputs: Qrerrorcorrectionl3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedrig`)
};

/**
* | output |
* | --- |
* | "Low" |
*
* @param {Qrerrorcorrectionl3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrerrorcorrectionl3 = /** @type {((inputs?: Qrerrorcorrectionl3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrerrorcorrectionl3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrerrorcorrectionl3(inputs)
	return de_qrerrorcorrectionl3(inputs)
});
export { qrerrorcorrectionl3 as "qrErrorCorrectionL" }